import * as types from './types';

export const autopay = (userId, enabled) => ({
  type: types.AUTOPAY,
  payload: {
    userId,
    enabled
  }
});

export const autopayChange = (enabled) => ({
  type: types.AUTOPAY_CHANGE,
  payload: { enabled }
});

export const autopayChangeFailed = () => ({
  type: types.AUTOPAY_CHANGE_FAILED,
});
